/** Юрлица переключателя: только те, у кого есть данные в выбранном периоде (и в сравнении). */
import type { OzMeta } from "@/api/ozonAnalytics";
import type { Range } from "./period";

export interface LegalOption {
  id: string;
  label: string;
  /** выбранное юрлицо без данных в периоде: кнопка остаётся, но серая */
  noData?: boolean;
}

const overlaps = (r: { date_from: string; date_to: string }, p: Range): boolean =>
  r.date_from <= p.to && r.date_to >= p.from;

/** Юрлица (в порядке `legalNames`), чей [date_from, date_to] пересекает период или сравнение
 *  (границы включительно). Юрлицо без диапазона данных нет — не попадает. */
export function legalsWithData(
  legalNames: string[],
  ranges: OzMeta["legal_ranges"],
  period: Range,
  cmp: Range | null,
): string[] {
  return legalNames.filter((name) => {
    const r = ranges.find((x) => x.legal_name === name);
    return !!r && (overlaps(r, period) || (cmp !== null && overlaps(r, cmp)));
  });
}

/** Юрлица вкладки «По дням»: витрины финансов (`/meta`) ∪ витрины заказов (`data_through` ответа
 *  `/daily`; null — ещё не пришёл) ∪ выбранное — без отбора по датам фактов финансов: у кабинета
 *  могут быть заказы без начислений, а дни без данных матрица и так показывает пустыми. */
export function dailyLegals(
  legalNames: string[],
  ordersLegals: string[] | null,
  selected: string | null,
): string[] {
  const out = [...legalNames];
  const extra = [...(ordersLegals ?? []), ...(selected ? [selected] : [])]
    .filter((l, i, a) => !out.includes(l) && a.indexOf(l) === i)
    .sort((a, b) => a.localeCompare(b, "ru"));
  return [...out, ...extra];
}

/** Кнопки переключателя. Выбранное юрлицо, выпавшее из списка, остаётся с пометкой. */
export function legalOptions(active: string[], selected: string | null): LegalOption[] {
  const opts: LegalOption[] = [
    { id: "", label: active.length === 2 ? "Оба юрлица" : "Все юрлица" },
    ...active.map((l) => ({ id: l, label: l })),
  ];
  if (selected && !active.includes(selected)) {
    opts.push({ id: selected, label: `${selected} — нет данных за период`, noData: true });
  }
  return opts;
}
